import styled from 'styled-components'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const tabletDownQuery = createResponsiveBreakpointQuery('tabletDown', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.bannerSmallDesktopInclusiveDown
})

export const BannerContainer = styled.div`
  height: 56px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.player50};
  color: #fff;
  position: relative;
  pointer-events: auto;

  @media ${tabletDownQuery} {
    flex-direction: column;
    height: auto;
    padding: 16px;
  }
`

export const BannerText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutralC20};

  @media ${tabletDownQuery} {
    text-align: left;
  }
`

export const HighlightedText = styled.strong`
  font-size: 16px;
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.neutralC20};

  @media ${tabletDownQuery} {
    margin-bottom: 8px;
    margin-right: 0;
  }
`

export const CloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  right: 37px;
  top: 50%;
  transform: translateY(-50%);
`
